import { defaultAnimateLayoutChanges, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { CSSProperties, ReactNode } from "react";

import { DragHandleProps } from "./types";

export type SortableItemProps = {
  id: string;
  children: (props: {
    dragHandleProps: DragHandleProps;
    isDragging: boolean;
    isOver: boolean;
  }) => ReactNode;
  className?: string;
  disabled?: boolean;
  hidden?: boolean;
};

export const SortableItem = ({
  id,
  children,
  className,
  disabled,
  hidden,
}: SortableItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isOver,
  } = useSortable({
    id,
    disabled,
    animateLayoutChanges: (args) =>
      defaultAnimateLayoutChanges({ ...args, wasDragging: true }),
  });
  const style: CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
    display: hidden ? "none" : "unset",
  };

  return (
    <div ref={setNodeRef} style={style} className={className}>
      {children({
        dragHandleProps: { attributes, listeners },
        isDragging,
        isOver,
      })}
    </div>
  );
};
